import dayjs from 'dayjs'
import { he } from 'element-plus/es/locale';

const $str = window.$str;

/** 基础配置参数 */
const cfg = {
  startTime: dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
  endTime: dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
  lineColor: "#3e4961", // 图表splitLine的颜色
  textColor: "#8b93aa", // 图表文字的颜色
}


/**
 * 获取linesChart的配置对象
 * @param {*} lines 图表要渲染的曲线的数据
 * @param {*} startTime 时间轴的最小坐标值
 * @param {*} endTime 时间轴的最大坐标值
 * @returns 
 */
export function getChartOption({ lines, startTime = cfg.startTime, endTime = cfg.endTime, timeType }) {
  const { yMin, yMax } = getYaxisRange(lines);
  console.log('AAAAAAA', startTime, endTime, getSeries(lines))

  return {
    // color: ['#1D77F5', '#FFC859', '#2AA523'],
    /** 坐标系-X轴 */
    xAxis: [
      {
        gridIndex: 0, // 坐标系idx
        name: $str.getKey('数据分析/时间'), // 轴线名称
        type: 'time', // 时间轴
        nameLocation: 'end',
        min: startTime, // 最小坐标值
        max: endTime, // 最大坐标值
        splitNumber: 20,
        axisLine: { // 坐标轴轴线的配置
          lineStyle: {
            color: cfg.lineColor
          }
        },
        position: 'bottom', // 轴线展示位置
        nameTextStyle: {
          color: cfg.textColor,
        },
        axisLabel: {
          color: cfg.textColor, // 坐标文字的颜色
          formatter: function (value, index) { // 格式化文本格式
            if (timeType === 'month') {
              return dayjs(value).format('MM-DD');
            } else {
              return dayjs(value).format('HH:mm');
            }

          },
        },
      },
    ],
    /** 坐标系-Y轴 */
    yAxis: [
      {
        gridIndex: 0, // 坐标系idx
        name: $str.getKey('数据分析/需量(kW)'),
        min: yMin,
        max: yMax,
        nameGap: 15,
        nameTextStyle: {
          align: 'center',
          color: cfg.textColor,
          padding: [0, 0, 0, 35]
        },
        nameLocation: 'end',
        type: 'value',
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: cfg.textColor,
        },
        axisLine: {
          lineStyle: {
            color: cfg.lineColor
          }
        }
      },
    ],
    /** 直角坐标系内绘图网格 */
    grid: [
      {
        top: 40,
        left: 50,
        right: 40,
        // height: '30%'
        bottom: 80,
      },
    ],
    /** 要渲染的charts系列配置 */
    series: getSeries(lines),
    // series: getSeries(...arguments),
    /** 全局坐标轴指示器: https://echarts.apache.org/zh/option.html#axisPointer */
    axisPointer: {
      link: [ // 不同轴的 axisPointer 可以进行联动: https://echarts.apache.org/zh/option.html#axisPointer.link
        {
          xAxisIndex: 'all'
        }
      ],
      label: {
        backgroundColor: '#777'
      }
    },
    /** 提示框组件的配置 */
    tooltip: createTooltip(timeType),
    /** 图例 */
    legend: {
      show: false,
      // data: ['实际需量', '负荷需量', '储能需量'],
      icon: 'circle',
      right: 40,
      itemWidth: 8,
      textStyle: {
        color: cfg.textColor
      }
    },
    /** 区域缩放组件：https://echarts.apache.org/zh/option.html#dataZoom */
    dataZoom: [
      {
        // type: 'slider', // 滑动条型数据区域缩放组件
        height: 12,
        bottom: 8,
        textStyle: {
          color: '#8392A5' // dataZoom 文字的颜色
        },
        // 两侧缩放手柄的 icon 形状，支持路径字符串
        handleIcon: 'path://M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        dataBackground: {
          areaStyle: {
            color: '#8392A5'
          },
          lineStyle: {
            opacity: 0.8,
            color: '#8392A5'
          }
        },
        brushSelect: true, // 开启刷选功能。在下图的 brush 区域可以按住鼠标左键后框选出选中部分。
        xAxisIndex: [0, 1]
      },
      {
        type: 'inside', // 内置型数据区域缩放组件。在图像上可使用鼠标缩放和拖动。
        xAxisIndex: [0, 1]
      }
    ],
    /** 禁止刷新图表时的动画效果 */
    animation: false,
  }
}



/** ====== [辅助：功能方法] =================================================================== */

/**
 * 获取坐标系Y轴的最大|最小值
 * @param {*} lines 
 * @returns 
 */
function getYaxisRange(lines = []) {
  const result = {
    yMin: 0,
    yMax: 100,
  }
  const hasUsefullData = lines.some(line => {
    return Array.isArray(line.data) && line.data.length > 0
  })
  if (hasUsefullData) {
    result.yMin = undefined;
    result.yMax = undefined;
  }

  return result;
}


/**
 * 创建一个系列对象---曲线
 * @param {*} name 曲线的名称 
 * @param {*} data 曲线采样点的数据 
 * @param {*} markLine 标线控制器 - max | average | min --- boolean 
 * @returns 
 */
function getSerieItem({ name, data, markLine, color }) {
  const serieItem = {
    name,
    type: 'line',
    showSymbol: false, // 是否显示数据位置的symbol符号：否，只在 tooltip hover 的时候显示。
    color, // 此处设置color，是为了能够让ToolTip取到line的颜色值
    lineStyle: {
      width: 1,
      // color: 'rgba(255,255,255,1)',
      color,
    },
    data, // 线数据
    markLine: {
      data: [],
      label: {
        show: true,
        position: 'insideEndTop',
        color: 'inherit',
      },
      lineStyle: {
        // color: 'rgba(255,255,255,1)',
        color,
        // width: 1,
        opacity: 1.0, // 可以通过透明度控制markLine的显隐
      }
    }
  }

  if (markLine.min) {
    const minMarkLine = {
      name: `${name}-${$str.getKey('数据分析/最小值')}`,
      type: 'min',
      label: {
        formatter: '{b}: {c}'
      }
    }
    serieItem.markLine.data.push(minMarkLine);
  }

  if (markLine.average) {
    const minMarkLine = {
      name: `${name}-${$str.getKey('数据分析/平均值')}`,
      type: 'average',
      label: {
        formatter: '{b}: {c}'
      }
    }
    serieItem.markLine.data.push(minMarkLine);
  }

  if (markLine.max) {
    const minMarkLine = {
      name: `${name}-${$str.getKey('数据分析/最大值')}`,
      type: 'max',
      label: {
        formatter: '{b}: {c}'
      }
    }
    serieItem.markLine.data.push(minMarkLine);
  }

  return serieItem;
}

/**
 * 创建图表配置项的 series 对象
 * @param {*} lines 曲线配置项列表
 * @returns 
 */
function getSeries(lines = []) {
  const series = [];

  lines.forEach(line => {
    const serieItem = getSerieItem(line);
    series.push(serieItem);
  })

  return series;
}


/**
 * 创建Tooltip配置对象
 * @param {*} timeType 
 * @returns 
 */
function createTooltip(timeType) {
  const timeFormatter = (value) => {
    // 格式化时间：如果是时间戳，转换为年月日时分秒；如果是时间字符串，直接使用
    let timeValue = value;
    if (typeof timeValue === 'number' || (typeof timeValue === 'string' && /^\d+$/.test(timeValue))) {
      // 判断是否是时间戳（毫秒或秒）
      const timestamp = Number(timeValue);
      const isMillisecond = timestamp > 946684800000; // 2000-01-01的时间戳（毫秒）
      if (timeType === 'month') {
        timeValue = dayjs(isMillisecond ? timestamp : timestamp * 1000).format('YYYY-MM-DD');
      } else {
        timeValue = dayjs(isMillisecond ? timestamp : timestamp * 1000).format('YYYY-MM-DD HH:mm:ss');
      }
    } else if (timeValue instanceof Date) {
      if (timeType === 'month') {
        timeValue = dayjs(timeValue).format('YYYY-MM-DD');
      } else {
        timeValue = dayjs(timeValue).format('YYYY-MM-DD HH:mm:ss');
      }
    } else if (typeof timeValue === 'string') {
      // 如果已经是时间字符串，根据 timeType 格式化
      if (timeType === 'month') {
        timeValue = dayjs(timeValue).format('YYYY-MM-DD');
      } else {
        timeValue = dayjs(timeValue).format('YYYY-MM-DD HH:mm:ss');
      }
    }
    return timeValue;
  };

  return {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    className: 'chart-tooltip',
    backgroundColor: 'rgba(255, 255, 255, 0.90)',
    borderWidth: 0,
    textStyle: {
      color: '#6A727C'
    },
    formatter: (params) => {
      let time = params[0].axisValue;
      time = timeFormatter(time);

      const str = (list) => {
        let t = '';
        for (const item of list) {
          const value = Array.isArray(item.data) ? item.data[1] : item.data;
          const formattedValue = isNaN(value) ? '--' : (Number(value).toFixed(2) / 1);
          t += /* html */`
            <div class="chart-tooltip__series" style="display: flex; align-items: center; justify-content: space-between; gap: 8px; line-height: 1.5;">
              <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                <div class="chart-tooltip__point" style="background: ${item.color}; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; vertical-align: middle;"></div>
                <div class="chart-tooltip__series-name" style="display: inline-block; vertical-align: middle;">${item.seriesName}</div>
              </div>
              <div class="chart-tooltip__value" style="flex-shrink: 0; display: inline-block; vertical-align: middle; text-align: right;">${formattedValue ?? '--'}</div>
            </div>`;
        }
        return t;
      };

      return /* html */`
        <div class="chart-tooltip__time" style="margin-bottom: 12px;">${time}</div>
        <div class="chart-tooltip__items-container">${str(params)}</div>        
      `;
    }
  }
}



